module.exports = __webpack_public_path__ + "static/media/market.45378bad.jpg";